module.exports = __webpack_public_path__ + "static/media/finance_insurance.fa30088a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/finance_insurance.jpeg
// module id = 1206
// module chunks = 0